import { getStaffBonus } from './utils';

export const CATEGORY_TO_INT = {
  affitto: 1,
  bollette: 2,
  materiali: 3,
  manutenzione: 4,
  marketing: 5,
  tasse_commissioni: 6,
  altro: 7,
};

export const INT_TO_CATEGORY = {
  1: 'affitto',
  2: 'bollette',
  3: 'materiali',
  4: 'manutenzione',
  5: 'marketing',
  6: 'tasse_commissioni',
  7: 'altro',
};

export const mapApiExpenseToUi = (row) => {
  const isStaff = Number(row.type) === 2;
  const valoreBonus = row.valoreBonus != null ? Number(row.valoreBonus) : 0;
  const value = Number(row.value) || 0;
  const isRecurring = Number(row.isRecurring) === 1 || Boolean(row.recurrenceId);
  const recurringEndRaw = row.recurringEnd;
  let periodicaFine = '';
  if (recurringEndRaw) {
    const parsed = String(recurringEndRaw);
    periodicaFine = parsed.length >= 7 ? parsed.slice(0, 7) : parsed;
  }

  return {
    id: row.idExpense,
    idExpense: row.idExpense,
    tipo: isStaff ? 'staff' : 'operativa',
    data: row.date,
    stato: row.paid ? 'pagato' : 'da_pagare',
    note: row.note || '',
    periodica: isRecurring,
    periodicaOgni: row.recurringEvery != null ? Number(row.recurringEvery) : 1,
    periodicaFine,
    recurrenceId: row.recurrenceId || null,
    poltronaId: row.idPoltrona != null ? String(row.idPoltrona) : '',
    bonusPct: row.bonusPct != null ? Number(row.bonusPct) : 0,
    valoreBonus,
    importoBase: isStaff ? Math.max(value - valoreBonus, 0) : undefined,
    categoria: INT_TO_CATEGORY[row.category] || 'altro',
    importo: isStaff ? undefined : value,
  };
};

export const mapUiExpenseToCreatePayload = (payload, chairs = []) => {
  const paid = payload.stato === 'pagato';
  const isRecurring = Boolean(payload.periodica);
  const recurringEvery = isRecurring ? Number(payload.periodicaOgni) || 1 : null;
  const recurringEnd = isRecurring ? payload.periodicaFine || null : null;

  if (payload.tipo === 'staff') {
    const bonusPct =
      payload.bonusPct !== '' && payload.bonusPct != null ? Number(payload.bonusPct) : null;
    const valoreBonus = bonusPct > 0 ? getStaffBonus({ ...payload, bonusPct }, chairs) : 0;
    const importoBase = Number(payload.importoBase) || 0;

    return {
      type: 2,
      date: payload.data,
      paid,
      value: importoBase + valoreBonus,
      idPoltrona: Number(payload.poltronaId),
      bonusPct,
      valoreBonus: valoreBonus || null,
      isRecurring,
      recurringEvery,
      recurringEnd,
    };
  }

  return {
    type: 1,
    date: payload.data,
    paid,
    value: Number(payload.importo) || 0,
    category: CATEGORY_TO_INT[payload.categoria] || 7,
    note: payload.note || null,
    isRecurring,
    recurringEvery,
    recurringEnd,
  };
};

export const mapUiExpenseToUpdatePayload = (expense, changes, chairs = []) => {
  const merged = { ...expense, ...changes };
  const body = { idExpense: expense.idExpense || expense.id };

  if (changes.stato !== undefined) {
    body.paid = changes.stato === 'pagato';
  }

  if (merged.tipo === 'staff') {
    if (
      changes.importoBase !== undefined
      || changes.bonusPct !== undefined
      || changes.poltronaId !== undefined
      || changes.fatturatoMese !== undefined
    ) {
      const bonusPct = merged.bonusPct != null ? Number(merged.bonusPct) : null;
      const valoreBonus = bonusPct > 0 ? getStaffBonus(merged, chairs) : 0;
      const importoBase = Number(merged.importoBase) || 0;
      body.value = importoBase + valoreBonus;
      body.bonusPct = bonusPct;
      body.valoreBonus = valoreBonus || null;
    }
    if (changes.poltronaId !== undefined) body.idPoltrona = Number(merged.poltronaId);
  } else if (changes.importo !== undefined) {
    body.value = Number(merged.importo) || 0;
  }

  if (changes.data !== undefined) body.date = merged.data;
  if (changes.note !== undefined) body.note = merged.note || null;
  if (changes.categoria !== undefined) body.category = CATEGORY_TO_INT[merged.categoria] || 7;
  if (changes.periodica !== undefined) body.isRecurring = Boolean(merged.periodica);
  if (changes.periodicaOgni !== undefined) body.recurringEvery = Number(merged.periodicaOgni) || 1;
  if (changes.periodicaFine !== undefined) body.recurringEnd = merged.periodicaFine || null;

  return body;
};
